import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import api from '../Services/api';

interface FetchByIdOptions {
  enabled?: boolean;
  queryParams?: Record<string, any>;
}

export function useFetchById<T>(
  key: string,
  url: string,
  id: string | number | null | undefined,
  options: FetchByIdOptions = {}
) {
  const {
    enabled = !!id,
    queryParams = {},
  } = options;

  const queryParamsKey = JSON.stringify(queryParams);

  return useQuery<T, AxiosError>({
    queryKey: [key, String(id), queryParamsKey],
    queryFn: async () => {
      if (!id) throw new Error('ID é necessário');
      const { data } = await api.get(`${url}/${id}`, { params: queryParams });
      return data;
    },
    enabled,
    refetchInterval: false, // dado de formulário: atualizar sobrescreveria a edição em andamento
  } as UseQueryOptions<T, AxiosError>);
}
